import React, { useState, useEffect } from "react";
import {
  Box, TextField, MenuItem, FormControl, InputLabel, Select, Typography
} from "@mui/material";
import theme from "../../configs/theme";

export default function VentaFilter({ onFilterChange }) {
  const [dateFilter, setDateFilter] = useState("");
  const [totalMin, setTotalMin] = useState("");
  const [totalMax, setTotalMax] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("");

  useEffect(() => {
    const min = totalMin === "" ? 0 : Number(totalMin);
    const max = totalMax === "" ? Number.MAX_SAFE_INTEGER : Number(totalMax);

    onFilterChange({
      dateFilter,
      totalRange: [min, max],
      paymentMethod,
    });
  }, [dateFilter, totalMin, totalMax, paymentMethod, onFilterChange]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        gap: 1,
        width: "100%",
        bgcolor: theme.tableColors.header,
        px: 1,
        py: 0.8,
        borderRadius: 2,
        flexWrap: "wrap",
      }}
    >
      <FormControl sx={{ width: "13vw" }}>
        <InputLabel>Fecha</InputLabel>
        <Select
          value={dateFilter}
          label="Fecha"
          onChange={(e) => setDateFilter(e.target.value)}
          sx={{ bgcolor: theme.tableColors.body }}
        >
          <MenuItem value="">Todas</MenuItem>
          <MenuItem value="hoy">Hoy</MenuItem>
          <MenuItem value="ayer">Ayer</MenuItem>
          <MenuItem value="semana">Última semana</MenuItem>
          <MenuItem value="15dias">Últimos 15 días</MenuItem>
          <MenuItem value="mes">Último mes</MenuItem>
          <MenuItem value="año">Último año</MenuItem>
        </Select>
      </FormControl>

      <FormControl sx={{ width: "12vw" }}>
        <InputLabel>Método de pago</InputLabel>
        <Select
          value={paymentMethod}
          label="Método de pago"
          onChange={(e) => setPaymentMethod(e.target.value)}
          sx={{ bgcolor: theme.tableColors.body }}
        >
          <MenuItem value="">Todos</MenuItem>
          <MenuItem value="Efectivo">Efectivo</MenuItem>
          <MenuItem value="Transferencia">Transferencia</MenuItem>
          <MenuItem value="Tarjeta Crédito">Tarjeta Crédito</MenuItem>
          <MenuItem value="Tarjeta Débito">Tarjeta Débito</MenuItem>
          <MenuItem value="QR">QR</MenuItem>
          <MenuItem value="Otro">Otro</MenuItem>
        </Select>
      </FormControl>

      <Box sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        bgcolor: theme.tableColors.body,
        px: 1,
        py: 1,
        borderRadius: 1,
      }}>
        <Typography variant="subtitle2">Total:</Typography>
        <TextField
          label="Mín"
          type="number"
          size="small"
          value={totalMin}
          onChange={(e) => {
            const value = e.target.value;
            setTotalMin(value === "" ? "" : value);
          }}
          onFocus={(e) => e.target.select()}
          sx={{ width: 110 }}
        />
        <TextField
          label="Máx"
          type="number"
          size="small"
          value={totalMax}
          onChange={(e) => {
            const value = e.target.value;
            setTotalMax(value === "" ? "" : value);
          }}
          onFocus={(e) => e.target.select()}
          sx={{ width: 112 }}
        />
      </Box>
    </Box>
  );
}
